export type IWildlifeManagementSixthSection = {
    Signature?: string,
    SignatureDate?: string,
}

export const WildlifeManagementSixthSectionInterface = (): IWildlifeManagementSixthSection => ({
    Signature: undefined,
    SignatureDate: undefined,
})